// País de residencia + código telefónico para el onboarding AFM.
export const COUNTRIES = [
  { name: "Argentina", dial: "+54" },
  { name: "Bolivia", dial: "+591" },
  { name: "Chile", dial: "+56" },
  { name: "Colombia", dial: "+57" },
  { name: "Costa Rica", dial: "+506" },
  { name: "Cuba", dial: "+53" },
  { name: "Ecuador", dial: "+593" },
  { name: "El Salvador", dial: "+503" },
  { name: "España", dial: "+34" },
  { name: "Estados Unidos", dial: "+1" },
  { name: "Guatemala", dial: "+502" },
  { name: "Honduras", dial: "+504" },
  { name: "México", dial: "+52" },
  { name: "Nicaragua", dial: "+505" },
  { name: "Panamá", dial: "+507" },
  { name: "Paraguay", dial: "+595" },
  { name: "Perú", dial: "+51" },
  { name: "Puerto Rico", dial: "+1" },
  { name: "República Dominicana", dial: "+1" },
  { name: "Uruguay", dial: "+598" },
  { name: "Venezuela", dial: "+58" },
  { name: "Brasil", dial: "+55" },
  { name: "Canadá", dial: "+1" },
  { name: "Reino Unido", dial: "+44" },
  { name: "Francia", dial: "+33" },
  { name: "Alemania", dial: "+49" },
  { name: "Italia", dial: "+39" },
  { name: "Portugal", dial: "+351" },
  { name: "Otro", dial: "+" },
];
